// winepassport#398 — normalización del archivo de imagen que sube el celular.
// En mobile el MIME puede venir vacío, con mayúsculas o como alias no canónico (image/jpg, image/pjpeg),
// y el nombre puede no tener extensión. El API necesita nombre + Content-Type coherentes.

const EXT_BY_MIME: Record<string, string> = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/gif': 'gif',
  'image/heic': 'heic',
  'image/heif': 'heif',
};

const MIME_BY_EXT: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  gif: 'image/gif',
  heic: 'image/heic',
  heif: 'image/heif',
};

const MIME_ALIASES: Record<string, string> = {
  'image/jpg': 'image/jpeg',
  'image/pjpeg': 'image/jpeg',
  'image/x-png': 'image/png',
  'image/heic-sequence': 'image/heic',
  'image/heif-sequence': 'image/heif',
};

export interface ResolvedImageUpload {
  name: string;
  type: string;
}

/**
 * Resuelve nombre y MIME coherentes. Orden: MIME informado (normalizado) si es soportado; si no, la extensión.
 * El nombre final siempre lleva la extensión del MIME resuelto (nunca extensión y Content-Type contradictorios).
 * Devuelve null si no se puede determinar un formato soportado.
 */
export function resolveImageUpload(fileName: string, reportedType: string): ResolvedImageUpload | null {
  const normalizedType = (reportedType || '').split(';')[0].trim().toLowerCase();
  const canonicalType = MIME_ALIASES[normalizedType] ?? normalizedType;

  const dot = fileName.lastIndexOf('.');
  const ext = dot >= 0 ? fileName.slice(dot + 1).toLowerCase() : '';
  const base = (dot > 0 ? fileName.slice(0, dot) : dot === 0 ? '' : fileName).trim() || 'profile';

  const type = EXT_BY_MIME[canonicalType] ? canonicalType : MIME_BY_EXT[ext];
  if (!type) {
    return null;
  }

  return { name: `${base}.${EXT_BY_MIME[type]}`, type };
}
